import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const drawVariants = {
  hidden: { pathLength: 0, opacity: 0 },
  visible: {
    pathLength: 1,
    opacity: 1,
    transition: { pathLength: { duration: 2, ease: 'easeInOut' }, opacity: { duration: 0.3 } },
  },
};

export const AnimatedDivider = ({ className = '' }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-50px' });

  return (
    <div ref={ref} className={className}>
      <svg width="100%" height="2" viewBox="0 0 1200 2" fill="none">
        <motion.line
          x1="0" y1="1" x2="1200" y2="1"
          stroke="currentColor"
          strokeWidth="2"
          variants={drawVariants}
          initial="hidden"
          animate={isInView ? 'visible' : 'hidden'}
        />
      </svg>
    </div>
  );
};

export const AnimatedArrow = ({ className = '' }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-50px' });

  return (
    <div ref={ref} className={className}>
      <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
        <motion.path
          d="M10 30 L50 30 M35 15 L50 30 L35 45"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          variants={drawVariants}
          initial="hidden"
          animate={isInView ? 'visible' : 'hidden'}
        />
      </svg>
    </div>
  );
};

export const AnimatedStar = ({ className = '', size = 40 }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-50px' });

  return (
    <div ref={ref} className={className}>
      <svg width={size} height={size} viewBox="0 0 40 40" fill="none">
        <motion.path
          d="M20 2 L24 16 L38 20 L24 24 L20 38 L16 24 L2 20 L16 16 Z"
          stroke="currentColor"
          strokeWidth="1.5"
          variants={drawVariants}
          initial="hidden"
          animate={isInView ? 'visible' : 'hidden'}
        />
      </svg>
    </div>
  );
};
